import { i18n } from "@/i18n";
import TrainingListView from "@/views/Training/TrainingListView.vue";
import TrainingDashboardView from "@/views/Training/TrainingDashboardView.vue";
import ContractSheetView from "@/views/Registration/ContractSheetView.vue";
import TrainingGroupAddEditView from "@/views/Training/TrainingGroupAddEditView.vue";
import TrainingLayoutView from "@/views/Training/TrainingLayoutView.vue";
import GlobalLayoutView from "@/views/Global/GlobalLayoutView.vue";
import AddEditView from "@/views/StudeaManager/AddEditView.vue";

export default {
  path: "/training",
  name: "Training",
  component: TrainingLayoutView,
  redirect: { name: "TrainingList" },
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.training_list"),
  },
  children: [
    {
      path: "list",
      name: "TrainingList",
      component: TrainingListView,
      meta: {
        title: i18n.global.t("page.training_list"),
        breadcrumb: false,
      },
    },
    {
      path: ":trainingId",
      name: "TrainingDashboardLayout",
      component: GlobalLayoutView,
      meta: {
        title: i18n.global.t("page.training_dashboard"),
        breadcrumb: true,
      },
      redirect: { name: "TrainingDashboard" },
      children: [
        {
          path: "dashboard",
          name: "TrainingDashboard",
          component: TrainingDashboardView,
          meta: {
            title: i18n.global.t("page.training_dashboard"),
            breadcrumb: false,
            displayTrainingName: true,
          },
        },
        {
          path: ":alias(training)/edit",
          name: "TrainingEdit",
          component: AddEditView,
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.training.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            notGeneric: true,
            backPath: "TrainingDashboard",
            displayTrainingName: true,
          },
        },
        {
          path: "group/add/:trainingCourseId",
          name: "TrainingGroupAdd",
          component: TrainingGroupAddEditView,
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            displayTrainingName: true,
          },
        },
        {
          path: "group/edit/:id",
          name: "TrainingGroupEdit",
          component: TrainingGroupAddEditView,
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            displayTrainingName: true,
          },
        },
        {
          path: ":alias(training)/edit",
          name: "TrainingEdit",
          component: AddEditView,
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.training.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            notGeneric: true,
            backPath: "TrainingDashboard",
          },
        },
      ],
    },
    {
      path: "contract/:id",
      name: "TrainingContract",
      component: ContractSheetView,
      meta: {
        title: i18n.global.t("page.contract"),
        breadcrumb: true,
      },
    },
  ],
};
